import http from "@/core/api/http";

export const userAPI = {
    /** 获取当前登录用户信息 */
    getUserInfo: () => {
        return http.get(`/user/current`);
    },
    /** 获取题目（后端目前缺失，404） */
    getProblem: () => {
        return http.get(`/problem`);
    },
    /** 分页查询用户 */
    getUserPage: (params) => {
        return http.get(`/user/page`, { params });
    },
    /** 更新用户信息 */
    updateUser: (username, data) => {
        return http.post(`/user/update/${username}`, data);
    },
    /** 绑定/更新 OJ 账号 */
    bindOj: (data) => {
        return http.post(`/user/oj-binding`, data);
    },
    /** 修改密码 */
    updatePassword: (data) => {
        return http.put(`/user/password`, data);
    },
    /** 管理员重置密码 */
    adminResetPassword: (data) => {
        return http.put(`/user/admin/reset-password`, data);
    },
    /** 管理员授予或撤销学生教练资格 */
    setStudentCoach: (userId, enabled) => {
        return http.put(`/user/admin/${userId}/student-coach`, { enabled });
    },
    /** 批量删除用户（逻辑删除） */
    batchDeleteUsers: (userIds) => {
        return http.delete(`/user/batch`, { data: userIds });
    },
};
